import { render, staticRenderFns } from "./ActionEditRMA.vue?vue&type=template&id=076f4ff3&lang=pug"
import script from "./ActionEditRMA.vue?vue&type=script&lang=js"
export * from "./ActionEditRMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports